export default __webpack_public_path__ + "static/media/Menu-dots.3195ab68.svg";